<template>
    <span
        ref="container"
        class="svg-container"
        v-on="$listeners"
    >
        <svg
            v-if="name"
            class="svg-icon"
            :class="{noStroke}"
            aria-hidden="true"
        >
            <use :href="`#znzs-icon-${name}`"/>
        </svg>
    </span>
</template>

<script setup>
import {ref, unref} from 'vue';
import {tryOnMounted} from '@vueuse/core';
import querySvg from './tasks.js';
const props = defineProps({
    name: {
        type: String,
    },
    src: {
        type: String,
    },
    noStroke: {
        type: Boolean,
        default: false,
    },
});

const container = ref();
const remoteSVG = ref();
async function getSvgIcon() {
    if (props.name || !props.src) {
        return;
    }
    const res = await querySvg(props.src);
    if (!res?.data) {
        return;
    }
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(res?.data, 'image/svg+xml');
    remoteSVG.value = svgDoc.querySelector('svg');
    unref(container)?.appendChild(remoteSVG.value);
}

tryOnMounted(() => {
    getSvgIcon();
});
</script>

<style lang="scss" scoped>
.svg {
    width: 100%;
    height: 100%;
    overflow: hidden;
    fill: currentColor;
    stroke: currentColor;
    * [stroke^='#'] {
        stroke: currentColor !important;
    }
    * [fill^='#'] {
        fill: currentColor !important;
    }
    &.noStroke {
        stroke: none;
        * [stroke^='#'] {
            stroke: none !important;
        }
    }
}

.svg-container {
    display: inline-block;
    width: 1em;
    height: 1em;
    overflow: hidden;
    .svg-icon {
        @extend .svg;
    }
    ::v-deep {
        svg {
            @extend .svg;
        }
    }
}
</style>